export const extractSpreadsheetIdFromUrl = (url: string): string | null => {
  const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  return match?.[1] ?? null;
};

export const extractFolderIdFromUrl = (url: string): string | null => {
  const match = url.match(/\/drive(?:\/u\/\d+)?\/folders\/([a-zA-Z0-9-_]+)/);
  return match?.[1] ?? null;
};
